import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
const useBillingCredentialManagementStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  mainContainer: {
    backgroundColor: palette.common.white,
    display: 'flex'
  },
  container: {
    padding: '24px 32px 16px 32px'
  },
  containerNav: {},
  containerBody: {
    height: 'calc(100vh - 60px)',
    overflow: 'scroll',
    width: '100%'
  },
  containerBod1y: {
    alignItems: 'flex-start',
    display: 'flex'
  },
  // propertyContent: {
  //   alignItems: 'flex-start',
  //   display: 'flex',
  // },
  // propertyNav: {
  //   alignItems: 'flex-start',
  //   display: 'flex',
  // },
  utilityCredentialItemTitle: {
    marginBottom: '12px'
  }
}));
export default useBillingCredentialManagementStyles;